<script>
    import user from "./user.vue";
    import navigation from "./navigation.vue";
    import { MemberBaseData } from "shared/Models/memberClasses";
    import f9button from "inputs/f9button.vue";
    import f9link from "inputs/f9link.vue";
    import { setIbeHost, setCorpHost } from "shared/Utilities/fetchUtilities";
    import { redirect } from "shared/Utilities/langUtilities";
    import travelCompanionVue from '../../FrontierMiles/Components/Sections/Account/Settings/travelCompanion.vue';
    import cancellationsSlider from "shared/Components/Sliders/cancellationsSlider.vue";
    import { dispatchWindowEvent } from "shared/eventBus";

    export default {
        props: {
            "ready": Boolean,
            "nav": Boolean,
            "showSignupSuccess": {
                type: Boolean,
                default: true
            },
            "ibeHost": {//IBE retrieves booking/member/etc data and *some* images
                type: String,
                default: ""
            },
            "corpHost": {//Corp retrieves content-managed stuff and *some* images
                type: String,
                default: ""
            },
            "headerLinks": {
                type: Array,
                default: () => [] 
            }
        },
        data() {
            return {
                imageRelativePath: "/Content/responsive/images/",
                navData: {
                    slider: false
                },
                isEs: window.location.host.indexOf("es.") === 0
            };
        },
        created() {
            setIbeHost(this.ibeHost);
            setCorpHost(this.corpHost);
            this.$on('cancellationSliderCreated', () => {
                dispatchWindowEvent("HeaderIsDoneLoading");
            });
        },
        mounted() {
            if (!this.isEs) {
                document.body.appendChild(this.$refs.esLink.$el);
            } else {
                document.body.appendChild(this.$refs.enLink.$el);
            }
        },
        watch: {
            ibeHost(newVal) {
                setIbeHost(newVal);
            },
            corpHost(newVal) {
                setCorpHost(newVal);
            }
        },
        methods: {
            showSignupSlider() {
                this.$refs.user.showSignupSlider();
            },
            redirectLanguage() {
                redirect(this.isEs ? "www" : "es");
            }
        },
        components: {
            user,
            navigation,
            f9button,
            f9link,
            cancellationsSlider
        }
    }
</script>

<template>
    <div class="header-top horizontal center between body-width noprint">
        <div class="horizontal center">
            <f9button v-if="nav" @click="navData.slider = !navData.slider" nostyle
                      class="hamburger hamburger--slider hide-md-lg hide-lg" :class="{ 'is-active': navData.slider }"
                      :aria-expanded="navData.slider" aria-label="show navigation menu">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </f9button>
            <div class="header-logo">
                <a href="https://www.flyfrontier.com/">
                    <img :src="ibeHost + imageRelativePath + 'frontier_logo_white.svg'" class="header-logo-img hide-sm hide-md" alt="">
                    <img :src="ibeHost + imageRelativePath + 'frontier_logo_white_notagline.svg'" class="header-logo-img logo-mobile hide-md-lg hide-lg" alt="">
                </a>
            </div>
        </div>
        <div id="header-breadcrumbs" class="breadcrumbs"></div>

        <div class="horizontal center">
            <navigation ref="nav" v-if="nav" :nav-data="navData" :header-links="headerLinks" :show-signup-slider="showSignupSlider"></navigation>

            <user ref="user" :show-signup-success="showSignupSuccess"></user>
        </div>
        <!--mp_global_switch_begins-->
        <f9link id="SpanishToggler" ref="esLink" v-show="!isEs" class="es-link-top noprint langLink" data-href="es.flyfrontier.com" data-lang="es" mporgnav="" @click="redirectLanguage">
            Español
        </f9link>
        <f9link id="EnglishToggler" ref="enLink" v-show="isEs" class="es-link-top noprint langLink" data-href="www.flyfrontier.com" data-lang="en" @click="redirectLanguage">
            English
        </f9link>
        <!--mp_global_switch_ends-->

        <cancellations-slider></cancellations-slider>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .header-top {
        background: #006643;
        color: @white;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        line-height: 1.5;
        letter-spacing: 0.24px;
    
        @{deep} a {
            &:hover, &:active, &:link, &:visited {
                color: @white;
            }
        }

        .header-logo {
            margin-top: 12px;
            display: flex;
            
            .header-logo-img {
                width: 185px;
                height: 35px;

                &.logo-mobile {
                    margin-left: 10px;
                }
            }
        }

        .breadcrumbs {
            margin: 0 6px 0 auto;
        }

    }
    @media @tablet {
        .header-top {
            height: 55px;

            .header-logo {
                margin-top: 0;

                .header-logo-img {
                    height: 18px;
                    width: 128px;
                    margin-top: 7px;
                }
            }
        }
    }
</style>

<style lang="less">
    @import "~less/shared.less";
    @import "~less/header.less";
    @import "~less-variables";

    .es-link-top {
        position: absolute;
        right: 21px;
        top: 2px;
        font-size: 11px;
        z-index: 10;
        text-decoration: none;
        line-height: 1.5;
        letter-spacing: 0.24px;

        &:link, &:visited, &:hover, &:active {
            color: @frontier-gray-xxlighter !important;
        }
        &:hover, &:active {
            text-decoration: underline;
        }
    }

    .js-bagsOverweightRadioSectionContainer {
        padding-left: 20px;
    }

    .additonal_radios {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .js-additionalCheckedRadioTemplate {
        display: flex;
    }
</style>